import { useTheme } from '#app/routes/resources+/theme-switch.tsx'

type BadgeSize = 'small' | 'medium'

/** Diamond fill + stripe gradients should align with this */
export const GTM_CLAUDE_ACCENT = '#D4762C'

export const gtmClaudeStripeGradient =
	'linear-gradient(180deg, #9a4a18 0%, #D4762C 42%, #e8a060 88%, #f0c090 100%)'

interface GtmClaudeBadgeProps {
	size?: BadgeSize
}

const sizeMap = {
	small: { diamond: 16, fontSize: 'text-sm', gap: 'gap-1.5' },
	medium: { diamond: 20, fontSize: 'text-base', gap: 'gap-2' },
} as const

export function GtmClaudeBadge({ size = 'medium' }: GtmClaudeBadgeProps) {
	const theme = useTheme()
	const textColor = theme === 'light' ? 'text-gray-900' : 'text-gray-100'
	const { diamond, fontSize, gap } = sizeMap[size]

	return (
		<div className={`flex items-center ${gap}`}>
			<svg
				width={diamond}
				height={diamond}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="12"
					y="2"
					width="14.14"
					height="14.14"
					rx="2"
					transform="rotate(45 12 2)"
					fill={GTM_CLAUDE_ACCENT}
				/>
			</svg>
			<span className={`font-semibold ${fontSize} ${textColor}`}>
				GTMClaude
			</span>
		</div>
	)
}
